import { render, staticRenderFns } from "./InvoiceWidget.vue?vue&type=template&id=533c2a14&scoped=true"
import script from "./InvoiceWidget.vue?vue&type=script&lang=js"
export * from "./InvoiceWidget.vue?vue&type=script&lang=js"
import style0 from "./InvoiceWidget.vue?vue&type=style&index=0&id=533c2a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c2a14",
  null
  
)

export default component.exports